import React from 'react';
import { Link } from 'react-router-dom';
import { ActionButton } from '../buttons';

const CartFoot = ({ onCartClose }) => (
  <div
    css={`
      padding: 0 16px 16px 16px;
      margin-top: 20px;
    `}
  >
    <Link to="/checkout/orderform">
      <ActionButton onClick={onCartClose}>Zur Kasse</ActionButton>
    </Link>
  </div>
);

export default CartFoot;



// WEBPACK FOOTER //
// ./src/components/cart/cartFooter.js